/**
 * Formatowanie kwot/dat i slowniki statusow dla "Kontrola faktur SFD".
 * Tylko tokeny kolorow var(--...) z v3sys-theme.css.
 */

export const formatujKwote = (kwota) => {
  if (kwota === null || kwota === undefined || kwota === '' || Number.isNaN(Number(kwota))) return '—';
  return `${Number(kwota).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} zł`;
};

/** '2026-09-02' -> '02.09.2026' */
export const formatujDate = (iso) => {
  if (!iso) return '—';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : String(iso);
};

/** '2026-09-03T10:12:00' -> '03.09.2026 10:12' */
export const formatujDateCzas = (iso) => {
  if (!iso) return '—';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]} ${m[4]}:${m[5]}` : formatujDate(iso);
};

/** '2026-09' -> 'wrzesień 2026' */
export const formatujMiesiac = (yyyyMm) => {
  const m = String(yyyyMm || '').match(/^(\d{4})-(\d{2})$/);
  if (!m) return String(yyyyMm || '—');
  const nazwy = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
  return `${nazwy[Number(m[2]) - 1] || m[2]} ${m[1]}`;
};

/** Data lokalna -> 'YYYY-MM-DD' (bez UTC, zeby o 00:30 nie cofac dnia). */
export const dataISO = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  const p = (n) => String(n).padStart(2, '0');
  return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}`;
};
export const dzisISO = () => dataISO(new Date());
export const dniWsteczISO = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return dataISO(d); };
export const poczatekRokuISO = () => `${new Date().getFullYear()}-01-01`;
/** "Caly czas": portal SFD ma dokumenty od tego roku. */
export const OD_CALEJ_HISTORII = '2022-01-01';
/** Domyslny poczatek zakresu i pelnej historii (decyzja wlasciciela, ANEKS 2). */
export const OD_DOMYSLNE = '2026-04-01';

/** Szybkie wybory zakresu (od..dzis). */
export const SZYBKIE_ZAKRESY = [
  { id: '30', etykieta: '30 dni', od: () => dniWsteczISO(30) },
  { id: '90', etykieta: '90 dni', od: () => dniWsteczISO(90) },
  { id: 'kwiecien', etykieta: 'od 1 kwietnia 2026', od: () => OD_DOMYSLNE },
  { id: 'wszystko', etykieta: 'cały czas', od: () => OD_CALEJ_HISTORII },
];
export const domyslnyZakres = () => ({ od: OD_DOMYSLNE, do: dzisISO() });

export const STATUSY = {
  brak: { etykieta: 'Brak w systemie', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
  zgodna: { etykieta: 'Zgodna', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  kwota_inna: { etykieta: 'Inna kwota', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  tylko_system: { etykieta: 'Tylko w systemie', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  duplikat: { etykieta: 'Duplikat', kolor: 'var(--purple)', tlo: 'var(--purple-light)' },
  zly_sklep: { etykieta: 'Zły sklep', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  // ANEKS 2: faktura odnaleziona w systemie pod numerem WZ
  dodana_jako_wz: { etykieta: 'Dodana jako WZ', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  czesciowo_wz: { etykieta: 'Część WZ w systemie', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  podwojnie: { etykieta: 'Podwójnie: FS i WZ', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
};

/** Etykieta 'nieznanego adresu' - sklep_id=0 w filtrze /lista (ANEKS 1). */
export const NIEZNANY_ADRES = 'nieznany adres';
export const SKLEP_NIEZNANY_ID = 0;

export const TYPY = {
  faktura: 'Faktura',
  korekta: 'Korekta',
  wz: 'WZ',
  // ANEKS 6: paragony z NIP od SFD S02 Wroclaw Renoma (PA/nnnnnn/RRRR/S02/MM)
  paragon: 'Paragon',
};

/** Kolor odznaki paragonu (chip, typ w tabeli, pasek) - wolny token motywu. */
export const KOLOR_PARAGON = 'var(--cyan)';
export const TLO_PARAGON = 'var(--cyan-light)';

/** ANEKS 6d: XML OSOZ z maila bez PDF-a - EAN tylko z nauki (kody SFD) i po dokladnej nazwie. */
export const TOOLTIP_OSOZ_BEZ_PDF = 'bez PDF dopasowanie tylko z nauki i po nazwie';

/**
 * KSeF (migracja 052/053): XML FA(3) z KSeF podpiety pod wiersz kontroli jako plik dokumentu (plik.format 'fa3',
 * plik.zrodlo 'ksef') - dodawanie ta sama sciezka co OSOZ (/dodaj-osoz), ale GTIN z XML = EAN.
 * `zrodla` wiersza zawiera 'ksef', a `ksef` = {id, ksef_numer, status} (odznaka w kolumnie Numer).
 */
export const TOOLTIP_FA3 = 'XML FA(3) z KSeF — dodawanie bez kreatora (GTIN z XML = EAN, produkty muszą już być w systemie)';
export const ETYKIETA_FA3 = 'XML z KSeF';
export const FORMATY_BEZ_KREATORA = new Set(['osoz', 'fa3']);
export const maOdznakeKsef = (wiersz) => Array.isArray(wiersz?.zrodla) && wiersz.zrodla.includes('ksef');
export const STATUSY_KSEF = {
  nowa: 'nowa (do rozliczenia)', dopasowana: 'dopasowana do faktury w systemie', dodana: 'dodana do systemu',
  koszt: 'koszt', pominieta: 'pominięta', blad: 'błąd',
};

/**
 * Skad mamy plik dokumentu (ANEKS 4/6/6b/6d) - etykieta znacznika przy pliku.
 * - 'osoz'  -> 'XML+PDF' (XML OSOZ-EDI + PDF z kodami EAN z tego samego maila) albo 'tylko XML' (plik.pdf false);
 *              dodawanie przez /dodaj-osoz ("Dodaj z maila")
 * - 'fa3'   -> 'XML z KSeF' (XML FA(3) podpiety z KSeF, plik.zrodlo 'ksef'); dodawanie przez /dodaj-osoz ("Dodaj z KSeF")
 * - paragon -> 'z maila (XML)' albo 'z listy Renomy (bez XML)' (wiersz tylko z listy PDF, bez pliku)
 * - reszta  -> 'z maila' / 'z portalu'
 * Zwraca null, gdy nie ma czego pokazac.
 */
export const etykietaZrodlaPliku = (plik, wiersz = null) => {
  const paragon = wiersz?.typ === 'paragon';
  const zrodla = Array.isArray(wiersz?.zrodla) ? wiersz.zrodla : [];
  const pobrany = plik?.status === 'pobrany';
  if (plik?.format === 'osoz' && (pobrany || plik?.zrodlo)) return plik.pdf ? 'XML+PDF' : 'tylko XML';
  if (plik?.format === 'fa3' && pobrany) return ETYKIETA_FA3;
  if (paragon) {
    if (pobrany) return 'z maila (XML)';
    if (zrodla.includes('lista') || !zrodla.includes('xml')) return 'z listy Renomy (bez XML)';
    return null;
  }
  if (!plik || (!pobrany && !plik.zrodlo)) return null;
  return plik.zrodlo === 'mail' ? 'z maila' : 'z portalu';
};

/** Paragon bez pliku XML - nie da sie dodac, trzeba poczekac na maila z Renomy. */
export const TOOLTIP_PARAGON_BEZ_XML = 'brak pliku - poczekaj na maila z XML';

/** Chipy filtrow - wartosci `filtr` z kontraktu (GET /lista). */
export const FILTRY = [
  { id: 'brak', etykieta: 'Brakujące faktury', licznik: 'brak_faktur', kolor: 'var(--danger)' },
  { id: 'brak_korekty', etykieta: 'Brakujące korekty', licznik: 'brak_korekt', kolor: 'var(--danger)' },
  { id: 'zgodne', etykieta: 'Zgodne', licznik: null, kolor: 'var(--success)' },
  { id: 'kwota_inna', etykieta: 'Inna kwota', licznik: 'kwota_inna', kolor: 'var(--warning)' },
  { id: 'tylko_system', etykieta: 'Tylko w systemie', licznik: 'tylko_w_systemie', kolor: 'var(--info)' },
  { id: 'duplikaty', etykieta: 'Duplikaty', licznik: 'duplikaty', kolor: 'var(--purple)' },
  { id: 'zly_sklep', etykieta: 'Zły sklep', licznik: 'zly_sklep', kolor: 'var(--warning)' },
  { id: 'dodane_jako_wz', etykieta: 'Dodane jako WZ', licznik: 'dodane_jako_wz', kolor: 'var(--info)' },
  { id: 'podwojnie', etykieta: 'Podwójnie', licznik: 'podwojnie', kolor: 'var(--danger)' },
  // licznik z podsumowanie.wz.bez_faktury (strona doklada go do `liczby`)
  { id: 'wz_bez_faktury', etykieta: 'WZ bez faktury', licznik: 'wz_bez_faktury', kolor: 'var(--orange)' },
  // ANEKS 6: wszystkie paragony Renomy (najpierw 'brak'); licznik = paragony bez systemu
  { id: 'paragony', etykieta: 'Paragony', licznik: 'paragony_brak', kolor: 'var(--cyan)' },
  { id: 'wszystkie', etykieta: 'Wszystkie', licznik: 'w_portalu', kolor: 'var(--primary)' },
];
